/* eslint-disable no-undef */
module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '8kitcdai',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
